import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "user-detail-expanded",
  "data-testid": "user-detail-expanded"
}
const _hoisted_2 = {
  key: 0,
  class: "skeleton skeleton-row",
  style: {"max-width":"20rem"}
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-0"
}
const _hoisted_4 = { class: "detail-columns" }
const _hoisted_5 = { class: "detail-column" }
const _hoisted_6 = {
  class: "mb-0",
  "data-testid": "user-detail-profile"
}
const _hoisted_7 = { class: "stat-tiles" }
const _hoisted_8 = {
  class: "stat-tile",
  "data-testid": "stat-failed-logins"
}
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = {
  class: "stat-tile",
  "data-testid": "stat-successful-logins"
}
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = { class: "detail-column" }
const _hoisted_13 = {
  key: 0,
  class: "list-unstyled mb-0",
  "data-testid": "role-list"
}
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_15 = {
  key: 1,
  class: "text-muted small d-block"
}
const _hoisted_16 = {
  class: "list-unstyled mb-0",
  "data-testid": "linked-profiles"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 0,
  class: "detail-column",
  "data-testid": "ldap-groups"
}
const _hoisted_23 = {
  key: 0,
  class: "list-unstyled mb-0 scrollable-list"
}
const _hoisted_24 = {
  key: 1,
  class: "text-danger small",
  "data-testid": "ldap-account-not-found"
}
const _hoisted_25 = {
  key: 2,
  class: "text-muted small"
}
const _hoisted_26 = {
  key: 0,
  class: "blocker-section"
}
const _hoisted_27 = {
  class: "blocker-list",
  "data-testid": "blocker-list"
}
const _hoisted_28 = { class: "fw-semibold" }
const _hoisted_29 = { class: "action-row d-flex gap-2" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "alert alert-danger mt-2 mb-0"
}

import { ref, computed } from "vue";
import { useQuery, useMutation, useQueryClient } from "@tanstack/vue-query";
import { useUserDetailQuery, useDeleteUserMutation } from "../api.js";


export default {
  __name: 'UserDetailExpanded',
  props: {
	user: { type: Object, required: true },
},
  emits: ["edit", "deleted"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { data: detail, isPending, isError, error } = useQuery(useUserDetailQuery(props.user.id, true));

const blockerEntries = computed(() => Object.entries(detail.value?.blockers || {}));

const queryClient = useQueryClient();
const deleteMutation = useMutation(useDeleteUserMutation(queryClient));
const confirmingDelete = ref(false);
const deleteError = ref("");

const ldapGroupCn = (ldapId) => ldapId.match(/^cn=([^,]+)/i)?.[1] ?? ldapId;

const handleDelete = () => {
	deleteError.value = "";
	deleteMutation.mutate(props.user.id, {
		onSuccess: () => emit("deleted"),
		onError: (err) => {
			deleteError.value = err.message || "Der Account konnte nicht gelöscht werden.";
			confirmingDelete.value = false;
		},
	});
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPending))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Details konnten nicht geladen werden: " + _toDisplayString(_unref(error)?.message || _unref(error)), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("strong", { class: "detail-column-title" }, "Stammdaten", -1 /* CACHED */)),
                _createElementVNode("dl", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("dt", null, "Vorname", -1 /* CACHED */)),
                  _createElementVNode("dd", null, _toDisplayString(__props.user.firstname || '-'), 1 /* TEXT */),
                  _cache[4] || (_cache[4] = _createElementVNode("dt", null, "Nachname", -1 /* CACHED */)),
                  _createElementVNode("dd", null, _toDisplayString(__props.user.lastname || '-'), 1 /* TEXT */),
                  _cache[5] || (_cache[5] = _createElementVNode("dt", null, "E-Mail", -1 /* CACHED */)),
                  _createElementVNode("dd", null, _toDisplayString(__props.user.mail || '-'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(detail).failedLogins24h), 1 /* TEXT */),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "stat-label" }, "Fehlgeschlagene Logins (24h)", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(detail).successfulLogins14d), 1 /* TEXT */),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "stat-label" }, "Erfolgreiche Logins (14 Tage)", -1 /* CACHED */))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[14] || (_cache[14] = _createElementVNode("strong", { class: "detail-column-title" }, "Rollen", -1 /* CACHED */)),
                (__props.user.roles.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.roles, (role) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: role.id
                        }, [
                          _createTextVNode(_toDisplayString(role.title) + " ", 1 /* TEXT */),
                          (role.ldapId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _cache[9] || (_cache[9] = _createTextVNode(" (LDAP ", -1 /* CACHED */)),
                                _createElementVNode("code", null, _toDisplayString(ldapGroupCn(role.ldapId)), 1 /* TEXT */),
                                _cache[10] || (_cache[10] = _createTextVNode(") ", -1 /* CACHED */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, "Keine Rollen zugewiesen.")),
                (_unref(detail).employee || _unref(detail).student)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[13] || (_cache[13] = _createElementVNode("strong", { class: "detail-column-title" }, "Verknüpfte Profile", -1 /* CACHED */)),
                      _createElementVNode("ul", _hoisted_16, [
                        (_unref(detail).employee)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                              _createElementVNode("a", {
                                href: _unref(detail).employee.viewUrl,
                                "data-testid": "linked-employee"
                              }, [
                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-id-badge" }, null, -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(detail).employee.displayName) + " ", 1 /* TEXT */),
                                (_unref(detail).employee.employeeNumber)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "(MA: " + _toDisplayString(_unref(detail).employee.employeeNumber) + ")", 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 8 /* PROPS */, _hoisted_18)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_unref(detail).student)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                              _createElementVNode("a", {
                                href: _unref(detail).student.viewUrl,
                                "data-testid": "linked-student"
                              }, [
                                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-graduation-cap" }, null, -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(detail).student.displayName) + " (MNR: " + _toDisplayString(_unref(detail).student.id) + ") ", 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_21)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              (__props.user.isLdapAccount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _cache[15] || (_cache[15] = _createElementVNode("strong", { class: "detail-column-title" }, "LDAP-Gruppenmitgliedschaften", -1 /* CACHED */)),
                    (_unref(detail).ldapGroups && _unref(detail).ldapGroups.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).ldapGroups, (group) => {
                            return (_openBlock(), _createElementBlock("li", { key: group }, [
                              _createElementVNode("code", null, _toDisplayString(group), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : (_unref(detail).ldapGroups === null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Dieser Account konnte in LDAP nicht gefunden werden. Er existiert vermutlich nicht mehr. "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, "Keine Gruppenmitgliedschaften gefunden."))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            (blockerEntries.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _cache[16] || (_cache[16] = _createElementVNode("strong", { class: "detail-column-title" }, "Löschen nicht möglich, referenziert von:", -1 /* CACHED */)),
                  _createElementVNode("ul", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockerEntries.value, ([label, count]) => {
                      return (_openBlock(), _createElementBlock("li", { key: label }, [
                        _createElementVNode("span", null, _toDisplayString(label), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(count), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-secondary",
                "data-testid": "user-detail-edit",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('edit')))
              }, " Bearbeiten "),
              (_unref(detail).canDelete)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!confirmingDelete.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-sm btn-outline-danger",
                          "data-testid": "user-detail-delete",
                          onClick: _cache[1] || (_cache[1] = $event => (confirmingDelete.value = true))
                        }, " Löschen "))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-danger",
                            "data-testid": "user-detail-delete-confirm",
                            disabled: _unref(deleteMutation).isPending.value,
                            onClick: handleDelete
                          }, " Wirklich löschen? ", 8 /* PROPS */, _hoisted_30),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-link",
                            onClick: _cache[2] || (_cache[2] = $event => (confirmingDelete.value = false))
                          }, " Abbrechen ")
                        ], 64 /* STABLE_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            (deleteError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(deleteError.value), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
  ]))
}
}

}